<template>
  <div class="listContainer" @keyup.enter="onSearch">
    <!-- 面包屑 -->
    <a-breadcrumb class="breadcrumb">
      <span slot="separator">></span>
      <a-breadcrumb-item>工单数据</a-breadcrumb-item>
      <a-breadcrumb-item>
        <a @click="backHref">月工单</a>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <!-- 面包屑 end   -->
    <!-- 增加&搜索 -->
    <section v-show="!isHideDetails && !addHideIs">
      <section class="searchBox">
        <span class="addStyle">
          <a-button type="primary" icon="plus" @click="addHideIs = !addHideIs"
            >增加</a-button
          >
        </span>
        <span>
          <label>项目：</label>
          <a-select
            style="min-width: 160px"
            v-model="project_id"
            showSearch
            :filterOption="filterOption"
          >
            <a-select-option
              v-for="element in proList"
              :key="element.id"
              :value="element.id"
              >{{ element.project_name }}</a-select-option
            >
          </a-select>
        </span>
        <span>
          <label>门店：</label>
          <a-select
            style="min-width: 160px"
            v-model="retail_shop_id"
            showSearch
            :filterOption="filterOption"
          >
            <a-select-option
              v-for="element in shopList"
              :key="element.id"
              :value="element.id"
              >{{ element.name }}</a-select-option
            >
          </a-select>
        </span>
        <span>
          <label>日期：</label>
          <a-range-picker v-model="date" @change="onSelectDate" />
        </span>
        <span>
          <label>字符串：</label>
          <a-input
            style="width: 200px"
            placeholder="项目名|员工名|员工手机号"
            v-model="query_field"
          />
        </span>
        <span
          ><a-button @click="onReset" style="margin-right: 10px">重置</a-button>
          <a-button type="primary" icon="search" @click="onSearch"
            >搜索</a-button
          >
        </span>
      </section>
      <!-- 增加&搜索 end-->
      <section class="tableStyles">
        <table>
          <thead>
            <tr>
              <th v-for="(item, j) in thList" :key="j">{{ item }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-show="data.length < 1">
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>暂无</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr v-show="data.length > 0" v-for="(item, i) in data" :key="i">
              <td>{{ item.project_name }}</td>
              <td>{{ item.shop_name }}</td>
              <td>{{ item.create_time }}</td>
              <td>{{ item.user_name }}</td>
              <td>{{ item.work_count }}</td>
              <td>{{ Number(item.night_count) }}</td>
              <td>{{ Number(item.festival_day) }}</td>
              <td></td>
              <td>{{ Number(item.work_day) }}</td>
              <td>{{ Number(item.insurance) }}</td>
              <td>{{ Number(item.pre_amount) }}</td>
              <td>{{ Number(item.checked_guard) }}</td>
              <!-- <td>
                <a @click="detailsPage(item)">详情</a>
              </td> -->
            </tr>
          </tbody>
        </table>
      </section>
      <div class="paginationStyle" :loading="loading">
        <a-pagination
          showQuickJumper
          :defaultCurrent="page"
          :total="pagination.total"
          @change="onChange"
          :current="page"
        />
        <span>{{ "共：" + pagination.total + "条" }}</span>
      </div>
    </section>
    <!-- content end -->
    <!-- 批量导入 -->
    <addForm v-show="addHideIs" v-on:hideInAdd="hideInAdd" />
    <!-- 批量导入 end -->
    <!-- 详情 -->
    <!-- <MTDetails v-show="isHideDetails" :detailsVal="detailsVal" /> -->
    <!-- 详情 end -->
  </div>
</template>
<script>
import axios from "axios";
import addForm from "@/components/retail/addMonthForm"; //批量导入结算数据
// import MTDetails from "@/components/retail/MTDetails"; //详情
export default {
  data() {
    return {
      data: [],
      loading: false,
      page: 1,
      pagination: {},
      thList: [
        "项目名称",
        "门店",
        "日期",
        "员工",
        "基础单量",
        "夜间单量",
        "节假日补贴天数",
        "管理扣款",
        "出勤天数",
        "保险金额",
        "预支金额",
        "应发"
        // "操作",
      ],
      isHideDetails: false,
      detailsVal: {},
      query_field: "",
      addHideIs: false,
      proList: [],
      project_id: "",
      retail_shop_id: "",
      shopList: [],
      start_date: "",
      end_date: "",
      date: null
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  components: {
    addForm
  },
  mounted() {
    this.getData(); //获取列表
    this.getPro(); //获取客户列表
    this.getShops(); //获取门店
  },
  watch: {
    project_id() {
      this.retail_shop_id = "";
      this.getShops();
    }
  },
  methods: {
    onSelectDate(date, dateString) {
      this.start_date = dateString[0];
      this.end_date = dateString[1];
      // console.log(date, dateString);
    },
    getShops() {
      let url =
        this.httpsBasic.url + this.httpsBasic.retail + "Retail_shop/lists";
      axios
        .post(url, {
          per_page: 100000,
          project_id: this.project_id,
          token: window.localStorage.getItem("xnwfPcToken")
        })
        .then(res => {
          if (res.data.code == 200) {
            this.shopList = res.data.data.data;
            console.log(this.shopList);
          } else {
            this.$message.warning(res.data.message);
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
        });
    },
    getPro() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.trade +
        "Project/queryManagerProject";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          trade_id: 4
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proList = res.data.data;
            //  console.log(this.proList);
          }
        });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    onReset() {
      this.start_date = "";
      this.end_date = "";
      this.retail_shop_id = "";
      this.query_field = "";
      this.project_id = "";
      this.date = undefined;
      this.page = 1;
      this.getData();
    },
    detailsPage(item) {
      this.detailsVal = item;
      this.isHideDetails = true;
    },
    backHref() {
      this.isHideDetails = false;
      this.addHideIs = false;
    },
    onChangeDate(date, dateString) {
      this.start_date = dateString[0];
      this.end_date = dateString[1];
      //  console.log(this.searchDate);
    },
    onChange(pageNumber) {
      this.page = pageNumber;
      this.getData();
    },
    onSearch() {
      this.page = 1;
      this.getData();
    },
    reload() {
      this.$nextTick(function() {
        this.getData();
      });
    },
    getData() {
      // console.log(this.$store.state.token);
      this.loading = true;
      let url =
        this.httpsBasic.url +
        this.httpsBasic.retail +
        "Retail_order/adminOrderMonthLists";
      let params = {
        current_page: this.page,
        per_page: 10,
        query_field: this.query_field,
        project_id: this.project_id,
        retail_shop_id: this.retail_shop_id,
        start_date: this.start_date,
        end_date: this.end_date,
        token: window.localStorage.getItem("xnwfPcToken")
      };
      // console.log(params);
      axios
        .post(url, params)
        .then(res => {
          if (res.data.code == 200) {
            this.data = res.data.data.data;
            // console.log(this.data);
            this.loading = false;
            const pagination = { ...this.pagination };
            pagination.total = res.data.data.total;
            this.pagination = pagination;
          } else {
            this.$message.warning(res.data.message);
            this.loading = false;
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    hideInAdd() {
      this.addHideIs = false;
      this.reload();
    }
  }
};
</script>
<style lang="less" scoped>
@import url(../../style/listBasic.less);
.searchStyle {
  > input {
    margin: 0 20px;
    width: 200px;
  }
}
.listContainer {
  .searchBox {
    display: block;
    > span {
      display: inline-block;
      margin-right: 20px;
      margin-bottom: 10px;
    }
  }
}
</style>
